<template>
  <div>
    <p v-if="attachment.metadata.old">
      Status changed from <span class="badge" :class="getBadge(attachment.metadata.old)">{{ attachment.metadata.old }}</span> to <span class="badge" :class="getBadge(attachment.metadata.new)">{{ attachment.metadata.new }}</span>
    </p>
    <p v-else>
      Status set to <span class="badge" :class="getBadge(attachment.metadata.new)">{{ attachment.metadata.new }}</span>
    </p>
    <p v-if="isAutoResolved" class="lead pre-line">
      This incident was auto-resolved.
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      attachment: {
        type: Object,
        default: function () {
          return {};
        }
      }
    },
    computed: {
      isAutoResolved() {
        if (this.attachment.metadata.new === 'Resolved' && Object.keys(this.attachment.metadata).includes('auto_resolved')) {
          return this.attachment.metadata.auto_resolved;
        }

        return false;
      }
    },
    methods: {
      getBadge(status) {
        switch (status) {
          case 'New':
            return 'badge-danger';
          case 'Open':
            return 'badge-info';
          case 'Resolved':
            return 'badge-success';
        }
      }
    },
  }
</script>